export const logAnalyticsEvent = async ({ action, category, label }) => {
    window.gtag('event', action, {
        event_category: category,
        event_label: label,
    });
};
